import React from 'react';
import { Card, Collapse, Table } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccQueues } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const QueueManagementCenter: React.FC<Props> = ({ params }) => {
  const { data, isLoading } = useWccQueues(params);
  const workstations = (data as { workstations?: Record<string, unknown>[] })?.workstations ?? [];

  return (
    <Card id="queues" title="Queue management" style={{ marginTop: 16 }} loading={isLoading}>
      <Collapse
        items={workstations.map((ws) => ({
          key: String(ws.workstation_id),
          label: `${ws.workstation_name} — ${ws.queue_length} jobs (${ws.queue_hours}h)`,
          children: (
            <Table
              size="small"
              pagination={false}
              dataSource={[
                ws.current_job ? { role: 'Current', ...(ws.current_job as object) } : null,
                ws.next_job ? { role: 'Next', ...(ws.next_job as object) } : null,
                ...((ws.upcoming_jobs as Record<string, unknown>[]) || []).map((j) => ({
                  role: 'Upcoming',
                  ...j,
                })),
              ].filter(Boolean)}
              columns={[
                { title: '', dataIndex: 'role', width: 80 },
                { title: 'WO', dataIndex: 'work_order_number' },
                { title: 'Customer', dataIndex: 'customer_name' },
                { title: 'Operation', dataIndex: 'operation' },
                { title: 'Est. h', dataIndex: 'estimated_hours', width: 70 },
              ]}
            />
          ),
        }))}
      />
    </Card>
  );
};

export default QueueManagementCenter;
